/* @flow */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit    
  },
  container: {
    display: 'inline-flex',
    flexDirection: 'column',
    paddingBottom: '40px'
  }
});

const ZoomControl = props => {
  const { classes, handleZoomIn, handleZoomOut } = props
  
  return (
    <div className={classes.container} >
      <IconButton variant='fab' className={classes.button} variant="raised" color="primary"onClick={handleZoomIn}>
        <AddIcon />
      </IconButton>
      <IconButton className={classes.button} variant="raised" color="primary" onClick={handleZoomOut}>
        <RemoveIcon />
      </IconButton>
    </div>
  )
}

ZoomControl.propTypes = {
  handleZoomIn: PropTypes.func,
  handleZoomOut: PropTypes.func
}

ZoomControl.defaultProps = {
  handleZoomIn: () => console.log('zoom in clicked'),
  handleZoomOut: () => console.log('zoom out clicked')
}

export default withStyles(styles)(ZoomControl)



// WEBPACK FOOTER //
// ./src/components/ZoomControl.js